'use client';
import Script from 'next/script';

// First-party Umami tracker. Cookieless, so it is not gated by cookie consent. HOST is a same-origin
// path: in prod nginx proxies /stats/script.js and /stats/api/send to the umami container; in dev a
// Next rewrite (next.config.js, UMAMI_REWRITE_TARGET) does the same. Page views on route changes are
// tracked by the script itself; product events go through track() in utils/analytics.ts.
const WEBSITE_ID = process.env.NEXT_PUBLIC_UMAMI_WEBSITE_ID || '';
const HOST = (process.env.NEXT_PUBLIC_UMAMI_HOST_URL || '/stats').replace(/\/$/, '');

export default function Umami() {
  if (!WEBSITE_ID) return null;
  return (
    <Script
      src={`${HOST}/script.js`}
      data-website-id={WEBSITE_ID}
      data-host-url={HOST}
      // Query strings carry secrets (?bt= book tokens, ?st= share tokens, ?t= upload/owner tokens): record paths only.
      data-exclude-search="true"
      strategy="afterInteractive"
    />
  );
}
